import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Backdrop,
  CircularProgress,
  DialogActions,
} from "@mui/material";
import styled from "styled-components";
import api from "../../api/config";
import { useNotification } from "../../context/NotificationContext";
import StyledTextField from "./StyledTextField";
import { AddClientLocation, UpdateClientLocation } from "../../api/Client";

const Header = styled(DialogTitle)`
  background-color: #28929c;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px !important;
  background-color: #2b3342;
  color: white;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
`;

const Footer = styled(DialogActions)`
  background-color: #28929c;
  padding: 10px;
`;

export default function AddClientLocationModal({
  open,
  onClose,
  onSaveSuccess = () => {},
  isEdit = false,
  selectedClient = {},
  selectedLocation = {},
}) {
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();

  const [endpointName, setEndpointName] = useState("");
  const [npiName, setNpiName] = useState("");
  const [npiNumber, setNpiNumber] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [nexusLinkUid, setNexusLinkUid] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [port, setPort] = useState("");
  const [sendAET, setSendAET] = useState("");
  const [sendTLS, setSendTLS] = useState("");
  const [sendTLSVersion, setSendTLSVersion] = useState("");
  const [sendTLSProtocol, setSendTLSProtocol] = useState("");
  const [sendTLSKey, setSendTLSKey] = useState("");
  const [sendTLSCert, setSendTLSCert] = useState("");
  const [sendTLSRootCert, setSendTLSRootCert] = useState("");
  const [sendTLSRootCertPath, setSendTLSRootCertPath] = useState("");
  const [sendTLSRootCertPassword, setSendTLSRootCertPassword] = useState("");
  const [sendTLSRootCertKey, setSendTLSRootCertKey] = useState("");
  const [sendTLSRootCertKeyPath, setSendTLSRootCertKeyPath] = useState("");
  const [receiveIP, setReceiveIP] = useState("");
  const [receivePort, setReceivePort] = useState("");
  const [receiveAET, setReceiveAET] = useState("");
  const [receiveTLS, setReceiveTLS] = useState("");
  const [receiveTLSVersion, setReceiveTLSVersion] = useState("");
  const [receiveTLSProtocol, setReceiveTLSProtocol] = useState("");
  const [receiveTLSKey, setReceiveTLSKey] = useState("");
  const [receiveTLSRootCert, setReceiveTLSRootCert] = useState("");
  const [receiveTLSRootCertPath, setReceiveTLSRootCertPath] = useState("");
  const [receiveTLSRootCertPassword, setReceiveTLSRootCertPassword] =
    useState("");
  const [receiveTLSRootCertKey, setReceiveTLSRootCertKey] = useState("");
  const [receiveTLSRootCertKeyPath, setReceiveTLSRootCertKeyPath] =
    useState("");
  const [status, setStatus] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (isEdit && selectedClient) {
      setEndpointName(selectedClient.enpoint_name || "");
      setNpiName(selectedClient.npi_name || "");
      setNpiNumber(selectedClient.npi_number || "");
      setAddress(selectedClient.address || "");
      setCountry(selectedClient.country || "");
      setState(selectedClient.state || "");
      setZipcode(selectedClient.zipcode || "");
      setNexusLinkUid(selectedClient.nexusLink_uid || "");
      setIpAddress(selectedClient.sendIP || "");
      setPort(selectedClient.sendPort || "");
      setSendAET(selectedClient.sendAET || "");
      setSendTLS(selectedClient.sendTLS || "");
      setSendTLSVersion(selectedClient.sendTLSVersion || "");
      setSendTLSProtocol(selectedClient.sendTLSProtocol || "");
      setSendTLSKey(selectedClient.sendTLSKey || "");
      setSendTLSCert(selectedClient.sendTLSCert || "");
      setSendTLSRootCert(selectedClient.sendTLSRootCert || "");
      setSendTLSRootCertPath(selectedClient.sendTLSRootCertPath || "");
      setSendTLSRootCertPassword(selectedClient.sendTLSRootCertPassword || "");
      setSendTLSRootCertKey(selectedClient.sendTLSRootCertKey || "");
      setSendTLSRootCertKeyPath(selectedClient.sendTLSRootCertKeyPath || "");
      setReceiveIP(selectedClient.receiveIP || "");
      setReceivePort(selectedClient.receivePort || "");
      setReceiveAET(selectedClient.receiveAET || "");
      setReceiveTLS(selectedClient.receiveTLS || "");
      setReceiveTLSVersion(selectedClient.receiveTLSVersion || "");
      setReceiveTLSProtocol(selectedClient.receiveTLSProtocol || "");
      setReceiveTLSKey(selectedClient.receiveTLSKey || "");
      setReceiveTLSRootCert(selectedClient.receiveTLSRootCert || "");
      setReceiveTLSRootCertPath(selectedClient.receiveTLSRootCertPath || "");
      setReceiveTLSRootCertPassword(
        selectedClient.receiveTLSRootCertPassword || ""
      );
      setReceiveTLSRootCertKey(selectedClient.receiveTLSRootCertKey || "");
      setReceiveTLSRootCertKeyPath(
        selectedClient.receiveTLSRootCertKeyPath || ""
      );
      setStatus(selectedClient.status || "");
      setCreatedAt(selectedClient.created_at || "");
      setUpdatedAt(selectedClient.updated_at || "");
      setCreatedBy(selectedClient.createdBy || "");
      setUpdatedBy(selectedClient.updatedBy || "");
      setNotes(selectedClient.notes || "");
    } else {
      resetForm();
    }
  }, [isEdit, selectedClient]);

  const resetForm = () => {
    setEndpointName("");
    setNpiName("");
    setNpiNumber("");
    setAddress("");
    setCountry("");
    setState("");
    setZipcode("");
    setNexusLinkUid("");
    setIpAddress("");
    setPort("");
    setSendAET("");
    setSendTLS("");
    setSendTLSVersion("");
    setSendTLSProtocol("");
    setSendTLSKey("");
    setSendTLSCert("");
    setSendTLSRootCert("");
    setSendTLSRootCertPath("");
    setSendTLSRootCertPassword("");
    setSendTLSRootCertKey("");
    setSendTLSRootCertKeyPath("");
    setReceiveIP("");
    setReceivePort("");
    setReceiveAET("");
    setReceiveTLS("");
    setReceiveTLSVersion("");
    setReceiveTLSProtocol("");
    setReceiveTLSKey("");
    setReceiveTLSRootCert("");
    setReceiveTLSRootCertPath("");
    setReceiveTLSRootCertPassword("");
    setReceiveTLSRootCertKey("");
    setReceiveTLSRootCertKeyPath("");
    setStatus("");
    setCreatedAt("");
    setUpdatedAt("");
    setCreatedBy("");
    setUpdatedBy("");
    setNotes("");
  };

  const handleSave = async () => {
    setLoading(true);

    const payload = {
      enpoint_name: endpointName,
      npi_name: npiName,
      npi_number: npiNumber,
      address: address,
      country: country,
      state: state,
      zipcode: zipcode,
      nexusLink_uid: nexusLinkUid,
      sendIP: ipAddress,
      sendPort: port,
      sendAET: sendAET,
      sendTLS: sendTLS,
      sendTLSVersion: sendTLSVersion,
      sendTLSProtocol: sendTLSProtocol,
      sendTLSKey: sendTLSKey,
      sendTLSCert: sendTLSCert,
      sendTLSRootCert: sendTLSRootCert,
      sendTLSRootCertPath: sendTLSRootCertPath,
      sendTLSRootCertPassword: sendTLSRootCertPassword,
      sendTLSRootCertKey: sendTLSRootCertKey,
      sendTLSRootCertKeyPath: sendTLSRootCertKeyPath,
      receiveIP: receiveIP,
      receivePort: receivePort,
      receiveAET: receiveAET,
      receiveTLS: receiveTLS,
      receiveTLSVersion: receiveTLSVersion,
      receiveTLSProtocol: receiveTLSProtocol,
      receiveTLSKey: receiveTLSKey,
      receiveTLSRootCert: receiveTLSRootCert,
      receiveTLSRootCertPath: receiveTLSRootCertPath,
      receiveTLSRootCertPassword: receiveTLSRootCertPassword,
      receiveTLSRootCertKey: receiveTLSRootCertKey,
      receiveTLSRootCertKeyPath: receiveTLSRootCertKeyPath,
      status: status,
      created_at: createdAt,
      updated_at: updatedAt,
      createdBy: createdBy,
      updatedBy: updatedBy,
      notes: notes,
    };

    console.log("Payload:", payload);
    try {
      if (isEdit) {
        const response = await api.put(
          `${UpdateClientLocation}/${selectedClient.uuid}?CilentUID=${selectedClient.uuid}`,
          payload
        );

        console.log("Client Location updated successfully", response);
        showNotification("Client Location Updated", "success");
      } else {
        const response = await api.post(
          `${AddClientLocation}?clientUID=${selectedLocation.uuid}`,
          payload
        );
        console.log("Client Location Created successfully", response);
        showNotification("Client Location Created", "success");
      }
      onSaveSuccess();
      handleClose();
    } catch (error) {
      console.error("Error saving client location:", error);
      showNotification("Error saving client location", "error");
    }

    setLoading(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Header>Client Location - {selectedLocation?.npi_name}</Header>

      <Content>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Row>
            <StyledTextField
              required
              margin="dense"
              label="Endpoint Name"
              fullWidth
              variant="outlined"
              value={endpointName}
              onChange={(e) => setEndpointName(e.target.value)}
            />
          </Row>
          <Row>
            <StyledTextField
              required
              margin="dense"
              label="NPI Name"
              fullWidth
              variant="outlined"
              value={npiName}
              onChange={(e) => setNpiName(e.target.value)}
            />
            <StyledTextField
              required
              margin="dense"
              label="NPI Number"
              fullWidth
              variant="outlined"
              value={npiNumber}
              onChange={(e) => setNpiNumber(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Address"
              fullWidth
              variant="outlined"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Country"
              fullWidth
              variant="outlined"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="State"
              fullWidth
              variant="outlined"
              value={state}
              onChange={(e) => setState(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Zipcode"
              fullWidth
              variant="outlined"
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Nexus Link UID"
              fullWidth
              variant="outlined"
              value={nexusLinkUid}
              onChange={(e) => setNexusLinkUid(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send IP"
              fullWidth
              variant="outlined"
              value={ipAddress}
              onChange={(e) => setIpAddress(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send Port"
              fullWidth
              variant="outlined"
              value={port}
              onChange={(e) => setPort(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Send AET"
              fullWidth
              variant="outlined"
              value={sendAET}
              onChange={(e) => setSendAET(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS"
              fullWidth
              variant="outlined"
              value={sendTLS}
              onChange={(e) => setSendTLS(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS Version"
              fullWidth
              variant="outlined"
              value={sendTLSVersion}
              onChange={(e) => setSendTLSVersion(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Send TLS Protocol"
              fullWidth
              variant="outlined"
              value={sendTLSProtocol}
              onChange={(e) => setSendTLSProtocol(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS Key"
              fullWidth
              variant="outlined"
              value={sendTLSKey}
              onChange={(e) => setSendTLSKey(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS Cert"
              fullWidth
              variant="outlined"
              value={sendTLSCert}
              onChange={(e) => setSendTLSCert(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Send TLS Root Cert"
              fullWidth
              variant="outlined"
              value={sendTLSRootCert}
              onChange={(e) => setSendTLSRootCert(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS Root Cert Path"
              fullWidth
              variant="outlined"
              value={sendTLSRootCertPath}
              onChange={(e) => setSendTLSRootCertPath(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS Root Cert Password"
              fullWidth
              variant="outlined"
              value={sendTLSRootCertPassword}
              onChange={(e) => setSendTLSRootCertPassword(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Send TLS Root Cert Key"
              fullWidth
              variant="outlined"
              value={sendTLSRootCertKey}
              onChange={(e) => setSendTLSRootCertKey(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Send TLS Root Cert Key Path"
              fullWidth
              variant="outlined"
              value={sendTLSRootCertKeyPath}
              onChange={(e) => setSendTLSRootCertKeyPath(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive IP"
              fullWidth
              variant="outlined"
              value={receiveIP}
              onChange={(e) => setReceiveIP(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Receive Port"
              fullWidth
              variant="outlined"
              value={receivePort}
              onChange={(e) => setReceivePort(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive AET"
              fullWidth
              variant="outlined"
              value={receiveAET}
              onChange={(e) => setReceiveAET(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive TLS"
              fullWidth
              variant="outlined"
              value={receiveTLS}
              onChange={(e) => setReceiveTLS(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Receive TLS Version"
              fullWidth
              variant="outlined"
              value={receiveTLSVersion}
              onChange={(e) => setReceiveTLSVersion(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive TLS Protocol"
              fullWidth
              variant="outlined"
              value={receiveTLSProtocol}
              onChange={(e) => setReceiveTLSProtocol(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive TLS Key"
              fullWidth
              variant="outlined"
              value={receiveTLSKey}
              onChange={(e) => setReceiveTLSKey(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Receive TLS Root Cert"
              fullWidth
              variant="outlined"
              value={receiveTLSRootCert}
              onChange={(e) => setReceiveTLSRootCert(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive TLS Root Cert Path"
              fullWidth
              variant="outlined"
              value={receiveTLSRootCertPath}
              onChange={(e) => setReceiveTLSRootCertPath(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive TLS Root Cert Password"
              fullWidth
              variant="outlined"
              value={receiveTLSRootCertPassword}
              onChange={(e) => setReceiveTLSRootCertPassword(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Receive TLS Root Cert Key"
              fullWidth
              variant="outlined"
              value={receiveTLSRootCertKey}
              onChange={(e) => setReceiveTLSRootCertKey(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Receive TLS Root Cert Key Path"
              fullWidth
              variant="outlined"
              value={receiveTLSRootCertKeyPath}
              onChange={(e) => setReceiveTLSRootCertKeyPath(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Status"
              fullWidth
              variant="outlined"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Created At"
              fullWidth
              variant="outlined"
              value={createdAt}
              onChange={(e) => setCreatedAt(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Updated At"
              fullWidth
              variant="outlined"
              value={updatedAt}
              onChange={(e) => setUpdatedAt(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Created By"
              fullWidth
              variant="outlined"
              value={createdBy}
              onChange={(e) => setCreatedBy(e.target.value)}
            />
            <StyledTextField
              margin="dense"
              label="Updated By"
              fullWidth
              variant="outlined"
              value={updatedBy}
              onChange={(e) => setUpdatedBy(e.target.value)}
            />
          </Row>

          <Row>
            <StyledTextField
              margin="dense"
              label="Notes"
              fullWidth
              variant="outlined"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </Row>
        </div>
      </Content>

      <Footer>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave}>
          {isEdit ? "Update Client Location" : "Save Client Location"}
        </Button>
      </Footer>

      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
